import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useCompanies = () => {
  const { state: { companies = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'companies/list',
    params: { term: companies.term, offset: companies.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Empresas',
      count: _.get(data, 'count', 0),
      loading: _.get(companies, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, companies]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'companies', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'companies', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({
        type: 'companies',
        payload: { model: {}, formLoading: true },
      });
      let model = { active: true };

      if (data.id) {
        const response = await api.get('companies/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'companies', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'companies', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`companies/${path}`, model);

      mutate(data);

      showMessage('success', `Empresa ${editing ? 'atualizada' : 'criada'} com sucesso`);

      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const searchCnpj = async (cnpj, model) => {
    try {
      dispatch({ type: 'companies', payload: { formLoading: true } });

      let response = await api.get(`companies/cnpj-search`, { params: { cnpj } }),
        result = _.pick(response.data, 'name', 'tradeName', 'phone', 'email');

      dispatch({ type: 'companies', payload: { formLoading: false, model: { ...model, ...result } } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const resetPassword = async (data, actions) => {
    try {
      await api.put(`companies/reset-password`, data);
      showMessage('success', `Senha redefinida com sucesso`);
      actions.setSubmitting(false);
    } catch (error) {
      actions.setSubmitting(false);
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...companies,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      createOrUpdate,
      searchCnpj,
      resetPassword,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'companies', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default useCompanies;
